module.exports = __webpack_public_path__ + "static/mundosemorigem-0ed4d9af822c8a1a497645de61d194f9.mp4";